import { useEffect } from 'react'
import GoogleAnalytics from 'react-ga'

import { StoreProvider } from './store'
import Home from './pages/Home'
import FacebookPixel from './components/FacebookPixel'

const App = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      GoogleAnalytics.pageview(window.location.href)
    }
  }, [])

  return (
    <StoreProvider>
      <Home />
      <FacebookPixel />
    </StoreProvider>
  )
}

export default App
